<template>
  <div>
    <div class="row no-gutters">
      <div class="col-md-12">
        <KTCodePreview v-bind:title="'Master Kurikulum'">
          <template v-slot:toolbar>
            <!-- <b-button @click="getList()" class="button-colors mr-4">
                  <span style="display: contents;"><span class="text pr-4">Sync Data </span><b-icon icon="arrow-repeat"
                    style="color: white;"></b-icon></span>
                </b-button> -->
            <ButtonComponent colors="#21AE95" name="generate" @click.native="getList()"
              dataTitleTooltip="Sync Data" />
            <ButtonComponent colors="#3751E4" name="tambah" v-b-modal.modal @click.native="openModal('Tambah')"
              dataTitleTooltip="Tambah Data" />
          </template>
          <template v-slot:body>
            <v-card>
              <v-card-title>
                <v-spacer></v-spacer>
                <v-text-field v-model="search" label="Search" single-line hide-details></v-text-field>
              </v-card-title>
              <v-data-table :headers="headers" :items="dataKurikulum" :search="search" :loading="isLoading" class="custom-header">
                <template v-slot:item.no="{ item, index }">
                  {{ item.no }}
                </template>
                <template v-slot:item.file="{ item }">
                  <span @click="downloadItem(item.file)" class="cursor-hand">{{ item.file }}</span>
                </template>
                <template v-slot:item.status="{ item }">
                  <span v-if="item.status === true" class="mr-1">Aktif</span>
                  <span v-else class="mr-1">Tidak Aktif</span>
                </template>
                <template v-slot:item.status_dikti="{ item }">
                    <b-form-checkbox
                      id="checkbox-1"
                      v-model="item.status_dikti"
                      name="checkbox-1"
                      value=true
                      unchecked-value=""
                      :disabled="true"
                    >
                  </b-form-checkbox>
                </template>
                <template v-slot:item.action="{ item }">
                  <ButtonComponent name="eye" @click.native="redirectToView(item)"/>
                  <ButtonComponent colors="#3751E4" name="edit" v-b-modal.modal @click.native="openModal('Edit', item)"
                    dataTitleTooltip="Edit" />
                  <ButtonComponent colors="#EF4848" name="hapus" @click.native="deleteData(item.key)"
                    dataTitleTooltip="Hapus" />
                </template>
              </v-data-table>
            </v-card>
          </template>
        </KTCodePreview>

        <b-modal @ok="onSubmit" ok-title="Simpan" no-enforce-focus ok-variant="primary" cancel-title="Batal"
          cancel-variant="danger" id="modal" size="lg" :title="`${statusModal} Kurikulum`">
          <b-form>
            <div class="row no-gutters">
              <div class="col-5">
                <b-form-group label="Kurikulum :">
                  <b-form-input type="text" required v-model="request.curriculum"
                    placeholder="Masukkan Kurikulum"></b-form-input>
                </b-form-group>
              </div>
              <div class="col-6 offset-1">
                  <SelectComponent :data="prodi" :changeSelected="changeProdi" Title="Diklat"
                    :models="request.prodi" :placeholder="'Pilih Diklat'"></SelectComponent>
              </div>
            </div>

            <div class="row no-gutters">
                <div class="col-5">
                    <SelectComponent :data="semester" :changeSelected="changeSemester" Title="Tahun Akademik"
                    :models="request.semester" :placeholder="'Pilih Tahun Akademik'"></SelectComponent>
                </div>
                <div class="col-6 offset-1">
                  <b-form-group label="File :">
                    <!-- <b-form-file v-model="request.file" ref="fileInput" class="mt-3" accept="application/pdf" plain @change="handleFileChange"></b-form-file> -->
                    <input type="file" ref="file" @change="onFileUpload" accept="application/pdf" />
                    <p v-show="statusModal === 'Edit'" >File Sebelumnya: {{ request.filebefore }} &nbsp; <ButtonComponent :name="'csv'" @click.native="downloadItem(request.filebefore)" :dataTitleTooltip="'View File'"></ButtonComponent> </p>
                  </b-form-group>
                </div>
              </div>
  
              <div class="row no-gutters">
                <div class="col-5">
                  <b-form-group label="Status :">
                    <Select2 v-model="request.status" :options="statusE"
                      :settings="{ settingOption: value, multiple: false, width: '100%' }" :placeholder="`Pilih Status`" />
                  </b-form-group>
                </div>
                <div class="col-6 offset-1">
                  <b-form-group label="Jumlah SKS Lulus">
                    <b-form-input type="text" required placeholder="Jumlah SKS Lulus" v-model="request.sksLulus" disabled></b-form-input>
                  </b-form-group>
                </div>
              </div>
  
              <div class="row no-gutters">
                <div class="col-5">
                  <b-form-group label="Jumlah SKS Wajiib">
                    <b-form-input type="number" required placeholder="Jumlah SKS Wajib" v-model="request.sksWajib"></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-6 offset-1">
                  <b-form-group label="Jumlah SKS Pilihan">
                    <b-form-input type="number" required placeholder="Jumlah SKS Pilihan" v-model="request.sksPilihan"></b-form-input>
                  </b-form-group>
                </div>
              </div>
          </b-form>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .cursor-hand{
    cursor: pointer;
    color: blue;
    text-decoration: underline;
  }
</style>

<script>
import KTCodePreview from "@/view/content/CardContent.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Select2 from 'v-select2-component';
import ButtonComponent from "@/view/content/components/button/buttonComponent.vue"
import SelectComponent from "@/view/content/components/select/SelectComponent.vue";
import axios from "axios";

export default {
  data() {
    return {
      statusE: [
        { id: true, text: "Aktif" },
        { id: false, text: "Tidak Aktif" }
      ],
      statusModal: '',
      dataLogin: JSON.parse(localStorage.getItem('dataLogin')),
      dataKurikulum: [],
      request: {
        key: null,
        curriculum: null,
        file: null,
        status: null,
        prodi: null,
        semester: null,
        sksLulus: null,
        sksWajib: null,
        sksPilihan: null,
      },
      search: "",
      filebefore: null,
      headers: [
        { text: "No", value: "no", align: "center", sortable: false },
        { text: "Kurikulum", value: "curriculum" },
        { text: "Diklat", value: "prodi" },
        { text: "File", value: "file",  align: "center" },
        { text: "Status", value: "status", align: "center" },
        { text: "Status Neo", value: "status_dikti", align: "center" },
        { text: "Aksi", value: "action", align: "center", sortable: false }
      ],
      prodi: [],
      semester: [],
      fileUpload: null,
      isLoading: false,
    };
  },
  components: {
    KTCodePreview,
    ButtonComponent,
    SelectComponent,
    Select2
  },
  async mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Master" },
      { title: "Kurikulum" }
    ]);

    await this.getData();
    await this.getProdi();
    await this.getDataSemester();
  },
  watch: {
    'request.sksWajib': 'computeTotalState',
    'request.sksPilihan': 'computeTotalState',
  },
  methods: {
    openModal(status, itemData = null) {
      this.statusModal = status
      // reset form
      this.request = {
        key: null,
        curriculum: null,
        file: null,
        status: null,
        prodi: null,
        semester: null,
        sksLulus: null,
        sksWajib: null,
        sksPilihan: null,
      }
      if (status == 'Edit') {
        this.request.key = itemData.key
        this.request.curriculum = itemData.curriculum
        this.request.file = itemData.file
        this.request.filebefore = itemData.file
        this.request.status = itemData.status
        this.request.prodi = itemData.idProdi
        this.request.semester = itemData.idSemester
        this.request.sksLulus = itemData.sksLulus
        this.request.sksWajib = itemData.sksWajib
        this.request.sksPilihan = itemData.sksPilihan
      }
    },

    computeTotalState(){
      // Hitung total state berdasarkan nilai input
      const sksWajib = parseInt(this.request.sksWajib) || 0;
      const sksPilihan = parseInt(this.request.sksPilihan) || 0;

      this.request.sksLulus = sksWajib + sksPilihan;
    },

    async getList() {
      try {
        const swalWithLoading = this.$swal({
          title: 'Ambil data dari neofedder?',
          icon: 'info',
          showCancelButton: true,
          confirmButtonText: 'Ya',
          cancelButtonText: 'Tidak',
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33'
        });

        swalWithLoading.then(async (result) => {
          if (result.value) {
            this.dataKurikulum = [];

            // Menampilkan popup loading dengan animasi "Serious Turkey"
            const swalLoading = this.$swal({
              title: 'Sedang memproses...',
              html: `
                <div class="uiverse-loading">
                  <span class="dot"></span>
                  <span class="dot"></span>
                  <span class="dot"></span>
                  <span class="dot"></span>
                  <span class="dot"></span>
                </div>`,
              allowOutsideClick: false,
              didOpen: () => {
                // Bisa juga menampilkan loading spinner SweetAlert default
                this.$swal.showLoading();
              }
            });

            // Tambahkan custom CSS untuk loading icon
            const style = document.createElement('style');
            style.innerHTML = `
              .uiverse-loading {
                display: flex;
                justify-content: center;
                align-items: center;
                height: 50px;
              }

              .uiverse-loading .dot {
                width: 10px;
                height: 10px;
                margin: 4px;
                border-radius: 50%;
                background-color: #3085d6;
                animation: bounce 0.6s infinite alternate;
              }

              .uiverse-loading .dot:nth-child(2) {
                animation-delay: 0.2s;
              }

              .uiverse-loading .dot:nth-child(3) {
                animation-delay: 0.4s;
              }

              @keyframes bounce {
                to {
                  transform: translateY(-15px);
                }
              }
            `;
            document.head.appendChild(style);

            try {
              const apiResult = await axios.get('master_dikti/sync_kurikulum');
              this.refreshData(apiResult, 'Get');
            } catch (apiError) {
              this.$swal('Error Server');
            } finally {
              swalLoading.close(); // Tutup loading setelah selesai
            }
          } else {
            // User canceled, so do nothing
          }
        });
      } catch (err) {
        this.$swal('Error Server');
      }
    },

    async getData() {
      try {
        this.isLoading = true;
        const result = await axios.get(`master/curriculums`)
        if (this.dataKurikulum.length > 0) {
          this.dataKurikulum = [];
        }
        result.data.data.map((kurikulum, index) =>  {
          let obj = {
            no: index+1,
            key: kurikulum.key,
            curriculum: kurikulum.curriculum,
            file: kurikulum.file,
            status: kurikulum.status,
            status_dikti: kurikulum.status_dikti,
            idProdi: kurikulum.id_prodi,
            idSemester: kurikulum.id_semester,
            sksLulus: kurikulum.jumlah_sks_lulus,
            sksWajib: kurikulum.jumlah_sks_wajib,
            sksPilihan: kurikulum.jumlah_sks_pilihan,
            prodi: kurikulum.program_name,
          }
        this.filebefore = kurikulum.file;
        this.dataKurikulum.push(obj);
      })
        this.isLoading = false;
      } catch (err) {
          // this.$swal(`Failed Get data Kurikulum`);
          this.isLoading = false;
      } 
    },

    async getProdi() {
      if (this.prodi.length) {
        this.prodi = [];
      }
      await axios.get('master/study-programs')
        .then(response => {
          response.data.data.map((e, index) => {
            var object = { id: e.key, text: e.program_name }
            this.prodi.push(object);
            return index > e.length;
          });
        });
    },

    async changeProdi(selected) {
      this.request.prodi = selected;
    },
    
    async getDataSemester(){
      if (this.semester.length) {
        this.semester = [];
      }
      await axios.get(`master/generations`)
      .then(res => {
        res.data.data.map((sem,index) => {
          let semesters = {id: sem.key, text: sem.tahun +' - '+ sem.tahun_akhir};
          // if (sem.a_periode_aktif == 1) {
            this.semester.push(semesters)
            this.sortedDes()
          // }
          return index > sem.length
        })
      })
    },
    sortedDes() {
      return this.semester.sort((a, b) => {
          if (a.id && b.id) {
          if (b.text < a.text) return -1;
          if (b.text > a.text) return 1;
          return 0;
          }
      });
    },
    
    async changeSemester(selected) {
      this.request.semester = selected;
    },

    async onSubmit() {
      const form = this.request
      
      if(!form.prodi){
        this.$swal('Diklat Harus Diisi!');
      }else{
        if (form.key === null) {
          // store
          this.store(form)
        } else {
          this.update(form)
        }
      }
    },

    async store(form) {
      try {
        const file = this.fileUpload;
        if (file && file.type != "application/pdf") {
          this.$swal(`File Harus .pdf`);
        } else {
          const formData = new FormData()
          formData.append("curriculum", form.curriculum);
          formData.append("status", form.status);
          formData.append('file', file);
          formData.append('id_prodi', form.prodi);
          formData.append('id_semester', form.semester);
          formData.append('jumlah_sks_lulus', form.sksLulus);
          formData.append('jumlah_sks_wajib', form.sksWajib);
          formData.append('jumlah_sks_pilihan', form.sksPilihan);

          const kurikulum = this.dataKurikulum.filter(kur => kur.curriculum.toUpperCase() == form.curriculum.toUpperCase());
          if (kurikulum.length > 0) {
            this.$swal('Data already exist');
          }else{
            const response = await axios.post('master/curriculum', formData)
            this.refreshData(response, 'Store')
          }
        }
      } catch (err) {
          // this.$swal(`Failed`);
      }
    },

    async update(form) {
      try {
        const file = this.fileUpload;
        if (file && file.type != "application/pdf") {
          this.$swal(`File Harus .pdf`);
        } else {
          const formData = new FormData()
          formData.append("curriculum", form.curriculum);
          formData.append("status", form.status);
          formData.append('file', file);
          formData.append('id_prodi', form.prodi);
          formData.append('id_semester', form.semester);
          formData.append('jumlah_sks_lulus', form.sksLulus);
          formData.append('jumlah_sks_wajib', form.sksWajib);
          formData.append('jumlah_sks_pilihan', form.sksPilihan);
          const result = await axios.post(`master/curriculum/${form.key}`, formData);
          this.refreshData(result, 'Update');
        }
      } catch (err) {
          // this.$swal(`Failed`);
      }
    },

    onFileUpload() {
      this.fileUpload = this.$refs.file.files[0];
    },

    refreshData(result, alert) {
      if (result.data.meta.code == 200) {
        this.$swal(`Berhasil ${alert} Data`);
        this.getData()
      } else {
          this.$swal(result.data.meta.message);
      }
    },

    
    // openFileInput() {
    //   this.$refs.fileInput.click(); // Membuka jendela pemilihan file saat tombol "Edit" diklik
    // },
    // handleFileChange(event) {
    //   const file = event.target.files[0]; // Mendapatkan file yang dipilih oleh pengguna
    //   this.request.file = file.name; // Menyimpan nama file pada data properti
    // },

    async deleteData(key) {
      try {
        this.$swal({
          title: 'Are you sure?',
          text: 'You will not be able to recover this item!',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, delete it!',
          cancelButtonText: 'No, cancel!',
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33'
        }).then(async (result) => {
          if (result.value) {
            const res = await axios.get(`master_dikti/matkul_kurikulum/get_data/${key}`)
            if (res.data.data.length > 0) {
              this.$swal('Data matakuliah masih ada!.')
            }else{
              const result = await axios.delete(`master/curriculum/${key}`)
              this.refreshData(result, 'Delete')
            }
          } else {
            // User canceled, so do nothing
          }
        })
      } catch (err) {
          // this.$swal(`Failed`);
      }
    },

    redirectToView(index) {
      let view = {
        ...index,
      }
      this.$router.push({ name: 'detail-curriculum', params: { propsScoreComponent: view} })
    },

    downloadItem(label) {
      const externalRouteUrl = this.$endpoint + 'uploads/dokumen_kurikulum/' + label;
      window.open(externalRouteUrl, '_blank');
    },
  },
  computed: {
    config() {
      let dataConfig = {
        headers: { Authorization: `Bearer ${this.dataLogin.access_token}`, 'Content-Type': 'application/json' }
      }
      return dataConfig
    }
  }
}
</script>